import { Error } from '@procore/core-icons'
import React from 'react'
import { P } from '../Semantic'
import { Typography } from '../Typography'
import { colors } from '../_styles/colors'
import { addSubcomponents } from '../_utils/addSubcomponents'
import { StyledFieldFooter } from './Field.styles'

import { StyledField, StyledFieldHeader } from './Field.styles'
export const Field_ = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(function Field(props, ref) {
  return <StyledField {...props} ref={ref} />
})

export const FieldHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(function Field(props, ref) {
  return <StyledFieldHeader {...props} ref={ref} />
})

export const FieldFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    error?: React.ReactNode | string | boolean
  }
>(function FieldFooter({ error, ...props }, ref) {
  return (
    <StyledFieldFooter>
      {error ? (
        <P {...props} ref={ref}>
          <Error style={{ color: colors.red50 }} />
          {typeof error !== 'boolean' ? (
            <Typography color="red50">{error}</Typography>
          ) : null}
        </P>
      ) : (
        props.children
      )}
    </StyledFieldFooter>
  )
})

Field_.displayName = 'Field'
FieldHeader.displayName = 'Field.Header'
FieldFooter.displayName = 'Field.Footer'

export const Field = addSubcomponents(
  {
    Header: FieldHeader,
    Footer: FieldFooter,
  },
  Field_
)
